import SvgIcon, { SvgIconProps } from "./SvgIcon";

const TreesIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <g clipPath="url(#clip0_2736_46)">
            <path
              d="M14.2 19V22"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.4 18H21.7C21.8957 17.9973 22.0863 17.9371 22.2482 17.8271C22.4101 17.717 22.5361 17.5618 22.6106 17.3808C22.6852 17.1998 22.7049 17.001 22.6675 16.8088C22.63 16.6167 22.537 16.4398 22.4 16.3L19.4 13H19.7C19.8957 12.9973 20.0863 12.9371 20.2482 12.8271C20.4101 12.717 20.5361 12.5619 20.6106 12.3808C20.6852 12.1998 20.7049 12.001 20.6675 11.8088C20.63 11.6167 20.537 11.4398 20.4 11.3L17.4 8H17.6C17.8043 8.01843 18.0092 7.97361 18.1872 7.87162C18.3651 7.76963 18.5073 7.6154 18.5947 7.42984C18.682 7.24428 18.7101 7.03636 18.6753 6.83425C18.6405 6.63215 18.5444 6.44564 18.4 6.3L14.4 2L13 3.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.82395 16C5.38642 15.9744 4.95982 15.8532 4.57415 15.645C4.18849 15.4368 3.85312 15.1466 3.59165 14.7949C3.33018 14.4431 3.14896 14.0384 3.06073 13.6091C2.97249 13.1798 2.9794 12.7364 3.08095 12.31C2.71842 12.0081 2.4322 11.625 2.24554 11.1917C2.05888 10.7584 1.97703 10.2872 2.00665 9.81636C2.03627 9.34552 2.17651 8.8883 2.41599 8.48183C2.65548 8.07536 2.98745 7.7311 3.38495 7.477C3.03632 6.85766 2.9189 6.13465 3.05361 5.43681C3.18832 4.73897 3.56641 4.11162 4.12051 3.66653C4.67462 3.22145 5.36874 2.98754 6.07922 3.00649C6.78969 3.02544 7.47036 3.29601 7.99995 3.77C8.52966 3.29676 9.21011 3.02683 9.92018 3.00825C10.6303 2.98967 11.3239 3.22364 11.8776 3.66853C12.4314 4.11342 12.8093 4.74035 12.9441 5.43775C13.0789 6.13515 12.962 6.85777 12.6139 7.477C13.0115 7.73101 13.3436 8.07521 13.5831 8.48163C13.8227 8.88806 13.9631 9.34526 13.9928 9.81611C14.0225 10.287 13.9407 10.7582 13.7542 11.1915C13.5676 11.6248 13.2814 12.008 12.9189 12.31C13.0239 12.7508 13.0277 13.2096 12.9299 13.6521C12.8322 14.0946 12.6355 14.5091 12.3546 14.8647C12.0737 15.2202 11.716 15.5075 11.3081 15.705C10.9003 15.9025 10.4531 16.0051 9.99995 16.005H5.99995L5.82395 16Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 13L6 11"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 12L10 10"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.19995 22V8"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2736_46">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_2804_81)">
            <path
              d="M8 13L6 11"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 12L10 10"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.19995 22V8"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M14.2 19V22"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.4 18H21.7C21.8957 17.9973 22.0863 17.9371 22.2482 17.8271C22.4101 17.717 22.5361 17.5618 22.6106 17.3808C22.6852 17.1998 22.7049 17.001 22.6675 16.8088C22.63 16.6167 22.537 16.4398 22.4 16.3L19.4 13H19.7C19.8957 12.9973 20.0863 12.9371 20.2482 12.8271C20.4101 12.717 20.5361 12.5619 20.6106 12.3808C20.6852 12.1998 20.7049 12.001 20.6675 11.8088C20.63 11.6167 20.537 11.4398 20.4 11.3L17.4 8H17.6C17.8043 8.01843 18.0092 7.97361 18.1872 7.87162C18.3651 7.76963 18.5073 7.6154 18.5947 7.42984C18.682 7.24428 18.7101 7.03636 18.6753 6.83425C18.6405 6.63215 18.5444 6.44564 18.4 6.3L14.4 2L13 3.5"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.82395 16C5.38642 15.9744 4.95982 15.8532 4.57415 15.645C4.18849 15.4368 3.85312 15.1466 3.59165 14.7949C3.33018 14.4431 3.14896 14.0384 3.06073 13.6091C2.97249 13.1798 2.9794 12.7364 3.08095 12.31C2.71842 12.0081 2.4322 11.625 2.24554 11.1917C2.05888 10.7584 1.97703 10.2872 2.00665 9.81637C2.03627 9.34553 2.17651 8.88831 2.41599 8.48184C2.65548 8.07536 2.98745 7.7311 3.38495 7.47701C3.03632 6.85766 2.9189 6.13466 3.05361 5.43682C3.18832 4.73897 3.56641 4.11162 4.12051 3.66654C4.67462 3.22146 5.36874 2.98755 6.07922 3.0065C6.78969 3.02545 7.47036 3.29602 7.99995 3.77001C8.52966 3.29677 9.21011 3.02684 9.92018 3.00826C10.6303 2.98968 11.3239 3.22365 11.8776 3.66854C12.4314 4.11342 12.8093 4.74036 12.9441 5.43776C13.0789 6.13516 12.962 6.85778 12.6139 7.47701C13.0115 7.73102 13.3436 8.07521 13.5831 8.48164C13.8227 8.88807 13.9631 9.34527 13.9928 9.81612C14.0225 10.287 13.9407 10.7582 13.7542 11.1915C13.5676 11.6248 13.2814 12.008 12.9189 12.31C13.0239 12.7508 13.0277 13.2096 12.9299 13.6521C12.8322 14.0946 12.6355 14.5091 12.3546 14.8647C12.0737 15.2202 11.716 15.5076 11.3081 15.7051C10.9003 15.9025 10.4531 16.0051 9.99995 16.005H5.99995L5.82395 16Z"
              fill={props.stroke || "black"}
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2804_81">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default TreesIcon;
